import React from "react";
import styles from "./Password.module.scss";
import { Controller } from "react-hook-form";
import withLabelAndError from "../withLabelAndError";
import { InputAdornment, TextField } from "@mui/material";
import { combineClasses } from "@/lib/utils";
import EyeSlash from "@/components/SVGComponents/EyeSlash";
import Eye from "@/components/SVGComponents/Eye";
import {
  InputControlProps,
  WithLabelAndErrorComponent,
} from "@/types/formControls";

const Password = (props: InputControlProps) => {
  const {
    control,
    register,
    validations,
    name,
    placeholder,
    startIcon,
    error,
    ...rest
  } = props;

  const [showPassword, setShowPassword] = React.useState(false);
  const toggleShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const renderInput = (field = {}) => {
    return (
      <TextField
        {...field}
        {...rest}
        id={name}
        label=""
        variant="outlined"
        type={showPassword ? "text" : "password"}
        className={combineClasses(styles.inputRoot, error && styles.error)}
        placeholder={placeholder}
        slotProps={{
          input: {
            startAdornment: startIcon ? (
              <InputAdornment position="start">{startIcon}</InputAdornment>
            ) : null,
            endAdornment: (
              <InputAdornment position="end">
                {showPassword ? (
                  <EyeSlash
                    onClick={toggleShowPassword}
                    className={styles.eyeIcon}
                  />
                ) : (
                  <Eye
                    onClick={toggleShowPassword}
                    className={styles.eyeIcon}
                  />
                )}
              </InputAdornment>
            ),
          },
          htmlInput: {
            className: combineClasses(
              styles.inputField,
              startIcon && styles.startIcon
            ),
          },
        }}
      />
    );
  };

  if (control) {
    return (
      <Controller
        control={control}
        rules={validations}
        name={name}
        render={({ field }) => renderInput(field)}
      />
    );
  } else {
    const field = register?.(name, validations);
    return renderInput(field);
  }
};

const PasswordWithLabelAndError = withLabelAndError(
  Password as WithLabelAndErrorComponent
);

export default PasswordWithLabelAndError;
export { Password };
